/*
 * Hub pages in site search.
 *
 * Shopify search never indexes metaobject pages, so every hub (frame sizes,
 * colours, map locations, gift hubs ...) was invisible to it. This fetches the
 * hub index from templates/search.pfc-hub-index.liquid once per session,
 * matches the query in the browser and shows hub results ABOVE products:
 *   - predictive search dropdown: predictive-search.js calls decoratePredictive()
 *   - /search results page: fills #PfcHubSearchResults (sections/main-search.liquid)
 */
(function () {
  if (window.PFCHubSearch) return;

  var CACHE_KEY = 'pfc-hub-idx:v1:';
  var CACHE_TTL = 30 * 60 * 1000;
  var PREDICTIVE_LIMIT = 4;
  var PAGE_LIMIT = 8;

  var STOP = { the: 1, a: 1, an: 1, for: 1, of: 1, and: 1, with: 1, in: 1, my: 1, to: 1, on: 1, your: 1, our: 1 };
  // Both sides go through this, so US/UK spellings and mat/mount match each other.
  var SYN = {
    color: 'colour', colors: 'colour', gray: 'grey', center: 'centre',
    mat: 'mount', mats: 'mount', matte: 'mount', mounts: 'mount',
    personalized: 'personalised', personalize: 'personalise',
    favorite: 'favourite', xmas: 'christmas', photograph: 'photo', photographs: 'photo', picture: 'picture',
  };

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function normalize(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, '')
      .replace(/(\d)\s*(?:"|inches|inch|in\b)/g, '$1')
      .replace(/(\d+(?:\.\d+)?)\s*(?:x|×|by|\*)\s*(\d+(?:\.\d+)?)/g, '$1x$2')
      // Short side first on both sides, so "10x20" finds the 20" x 10" hub and
      // "36x24" finds 24x36.
      .replace(/(\d+(?:\.\d+)?)x(\d+(?:\.\d+)?)/g, function (m, a, b) {
        return parseFloat(a) <= parseFloat(b) ? a + 'x' + b : b + 'x' + a;
      })
      .replace(/(\d)\s+(cm|mm)\b/g, '$1$2');
  }

  function tokens(s) {
    var out = [];
    normalize(s)
      .split(/[^a-z0-9.]+/)
      .forEach(function (t) {
        t = t.replace(/^\.+|\.+$/g, '');
        if (!t || STOP[t]) return;
        if (SYN[t]) t = SYN[t];
        if (t.length > 3 && /[a-z]s$/.test(t) && !/ss$/.test(t)) t = t.slice(0, -1);
        if (t.length < 2 && !/\d/.test(t)) return;
        out.push(t);
      });
    return out;
  }

  function prepare(list) {
    return list.filter(Boolean).map(function (h, i) {
      h._T = tokens(h.t);
      h._K = tokens(h.g + ' ' + h.k);
      h._D = tokens(h.d);
      h._n = normalize(h.t);
      h._i = i;
      return h;
    });
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY + root());
      if (!raw) return null;
      var c = JSON.parse(raw);
      if (!c || Date.now() - c.ts > CACHE_TTL) return null;
      return c.data;
    } catch (e) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY + root(), JSON.stringify({ ts: Date.now(), data: data }));
    } catch (e) {}
  }

  var loading = null;
  var index = null;

  function load() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    var cached = readCache();
    if (cached) {
      index = prepare(cached);
      return Promise.resolve(index);
    }
    loading = fetch(root() + 'search?view=pfc-hub-index', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('hub index ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var data = JSON.parse(text.slice(text.indexOf('['), text.lastIndexOf(']') + 1)).filter(Boolean);
        writeCache(data);
        index = prepare(data);
        return index;
      })
      .catch(function () {
        loading = null;
        return [];
      });
    return loading;
  }

  function hit(list, qt) {
    var prefix = false;
    for (var i = 0; i < list.length; i++) {
      if (list[i] === qt) return 2;
      if (list[i].indexOf(qt) === 0) prefix = true;
    }
    return prefix ? 1 : 0;
  }

  function match(query, limit) {
    if (!index) return [];
    var qts = tokens(query);
    if (!qts.length) return [];
    var qn = normalize(query).trim();
    var allowMiss = qts.length >= 3 ? 1 : 0;
    var found = [];

    index.forEach(function (h) {
      var score = 0;
      var miss = 0;
      var inTitle = 0;
      qts.forEach(function (qt) {
        // A size ("16x20", "a4") is the most specific thing a visitor types.
        var w = /\d/.test(qt) ? 2 : 1;
        var t = hit(h._T, qt);
        if (t) {
          score += (t === 2 ? 10 : 7) * w;
          inTitle++;
          return;
        }
        var k = hit(h._K, qt);
        if (k) {
          score += k === 2 ? 5 : 3;
          return;
        }
        if (hit(h._D, qt)) {
          score += 1;
          return;
        }
        miss++;
      });
      if (miss > allowMiss) return;
      // Description-only matches are too loose to put above products.
      if (score < (qts.length - miss) * 3) return;
      score -= miss * 5;
      if (h._n === qn) score += 10;
      else if (h._n.indexOf(qn) !== -1) score += 8;
      if (inTitle === qts.length) score += 4;
      found.push({ h: h, s: score });
    });

    found.sort(function (a, b) {
      return b.s - a.s || a.h._T.length - b.h._T.length || a.h._i - b.h._i;
    });
    return found.slice(0, limit).map(function (f) {
      return f.h;
    });
  }

  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function predictiveMarkup(hubs) {
    var items = hubs
      .map(function (h, i) {
        var img = h.i
          ? '<img class="predictive-search__image" src="' + esc(h.i) + '" alt="" width="50" height="50" loading="lazy">'
          : '';
        return (
          '<li id="predictive-search-option-hub-' + (i + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false">' +
          '<a href="' + esc(h.u) + '" class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">' +
          img +
          '<div class="predictive-search__item-content">' +
          '<p class="predictive-search__item-heading h5">' + esc(h.t) + '</p>' +
          '<span class="predictive-search__item-vendor caption-with-letter-spacing">' + esc(h.g) + '</span>' +
          '</div></a></li>'
        );
      })
      .join('');
    return (
      '<div class="predictive-search__result-group pfc-hub-results">' +
      '<h2 id="predictive-search-hubs" class="predictive-search__heading text-body caption-with-letter-spacing">Shop by category</h2>' +
      '<ul class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-hubs">' +
      items +
      '</ul></div>'
    );
  }

  // Called by predictive-search.js after each render. The index may still be
  // loading on the first keystroke, so inject when it arrives if the term has
  // not moved on.
  function decoratePredictive(el) {
    var term = el.searchTerm;
    load().then(function () {
      if (el.searchTerm !== term) return;
      var results = el.querySelector('#predictive-search-results');
      if (!results) return;
      var old = results.querySelector('.pfc-hub-results');
      if (old) old.remove();
      var hubs = match(term, PREDICTIVE_LIMIT);
      if (!hubs.length) return;
      results.insertAdjacentHTML('afterbegin', predictiveMarkup(hubs));
    });
  }

  function renderPage() {
    var box = document.getElementById('PfcHubSearchResults');
    if (!box) return;
    var q = box.getAttribute('data-q') || '';
    if (!q.trim()) return;
    load().then(function () {
      var hubs = match(q, PAGE_LIMIT);
      if (!hubs.length) return;
      box.innerHTML =
        '<h2 class="pfc-hub-search__heading h3">Shop by category</h2>' +
        '<ul class="pfc-hub-search__grid list-unstyled">' +
        hubs
          .map(function (h) {
            return (
              '<li class="pfc-hub-search__item"><a class="pfc-hub-search__card link" href="' + esc(h.u) + '">' +
              (h.i
                ? '<img class="pfc-hub-search__img" src="' + esc(h.i.replace('width=160', 'width=400')) + '" alt="" width="200" height="200" loading="lazy">'
                : '<span class="pfc-hub-search__img pfc-hub-search__img--blank"></span>') +
              '<span class="pfc-hub-search__text">' +
              '<span class="pfc-hub-search__label caption-with-letter-spacing">' + esc(h.g) + '</span>' +
              '<span class="pfc-hub-search__title h5">' + esc(h.t) + '</span>' +
              '</span></a></li>'
            );
          })
          .join('') +
        '</ul>';
      box.hidden = false;
      var none = document.querySelector('[data-pfc-no-results]');
      if (none) none.hidden = true;
    });
  }

  window.PFCHubSearch = { load: load, match: match, decoratePredictive: decoratePredictive, _tokens: tokens };

  // Warm the index as soon as a visitor touches a search box.
  document.addEventListener(
    'focusin',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('input[type="search"], input[name="q"]')) load();
    },
    true
  );

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderPage);
  else renderPage();
})();
